import React from 'react';
import { TreeSelect as AntdTreeSelect } from 'antd';
import type { TreeSelectProps as AntdTreeSelectProps } from 'antd';
import { joinAriaIds, useWxbFieldIds } from '../_internal/fieldA11y';
import { resolvePopupContainer } from '../_internal/portalContainer';
import './TreeSelect.css';

export interface WxbTreeSelectProps extends AntdTreeSelectProps {
  label?: string;
  error?: string;
}

export const WxbTreeSelect: React.FC<WxbTreeSelectProps> = ({
  label,
  error,
  className = '',
  popupClassName = '',
  id,
  'aria-describedby': ariaDescribedBy,
  'aria-invalid': ariaInvalid,
  // 全屏下下拉就近渲染到触发器内;非全屏保持 antd 默认(body)。
  getPopupContainer = resolvePopupContainer,
  ...props
}) => {
  const { controlId, feedbackId } = useWxbFieldIds(id);
  const describedBy = joinAriaIds(ariaDescribedBy, error ? feedbackId : undefined);

  return (
    <div className="wxb-field">
      {label && <label className="wxb-label" htmlFor={controlId}>{label}</label>}
      <AntdTreeSelect
        {...props}
        id={controlId}
        className={`wxb-tree-select ${error ? 'wxb-tree-select-error' : ''} ${className}`}
        popupClassName={`wxb-tree-select-popup ${popupClassName}`}
        getPopupContainer={getPopupContainer}
        aria-describedby={describedBy}
        aria-invalid={ariaInvalid ?? (Boolean(error) || undefined)}
        status={error ? 'error' : props.status}
      />
      {error && <span id={feedbackId} className="wxb-help wxb-help-error" role="alert">{error}</span>}
    </div>
  );
};
